$(document).ready(function(){
	AOS.init();	
})

$('.link-grid-item__image a, .it-office-link, [href="https://www.instrotek.com/pages/nuclear-gauge-parts"], [href="https://www.instrotek.com/products/nuclear-gauge-operators-training"], [href="https://www.instrotek.com/pages/downloads#downloads-in-pdf-format"]').click(function(e){

	e.preventDefault();

	var link = $(this).attr('href');

	Swal.fire({
	  title: 'CPN is now part of the InstroTek Family.',
	  text: 'Go to Instrotek.com?',
	  showCancelButton: true,
	  confirmButtonText: 'Yes',
	  concelButtonText: 'No',
 	  imageUrl: '//cdn.shopify.com/s/files/1/0306/2824/9737/t/6/assets/instrotek-logo_x100.png?v=116877929464602966101669049405',
  	  imageHeight: 100,
  	  imageAlt: 'Instrotek Logo'	  
	}).then((result) => {
	  if (result.isConfirmed) {
	    window.location.href = link;
	  }
	})
});

$('[href="https://nuketrain.com/"]').click(function(e){

	e.preventDefault();

	var link = $(this).attr('href');

	Swal.fire({
	  title: 'Nuketrain.com is now part of the InstroTek Family.',
	  text: 'Go to Nuketrain.com?',
	  showCancelButton: true,
	  confirmButtonText: 'Yes',
	  concelButtonText: 'No',
 	  imageUrl: '//cdn.shopify.com/s/files/1/0306/2824/9737/t/6/assets/instrotek-logo_x100.png?v=116877929464602966101669049405',
  	  imageHeight: 100,
  	  imageAlt: 'Instrotek Logo'	  
	}).then((result) => {
	  if (result.isConfirmed) {
	    window.location.href = link;
	  }
	})
});

